<script>
	import Layout from '../Stores/Layout';
	import Menu from '../Stores/Menu';
	import Next from '../Stores/Next';
	import Product from '../Stores/Product';
	import Widget from '../Stores/Widget';
	import {tick} from 'svelte';

	function configurator() {
		Layout.product();
		Product.setStep(1);
	}

	async function previous() {
		Next.setCancel();
		Product.setPrevious();
		await tick();
	}

	async function next() {
		Next.setCancel();
		Product.setNext();
		await tick();

		/*
		const scroll = () => {
			const header = 60;
			const base = jQuery($Widget.container);
			const target = jQuery($Widget.current);
			const top = target.offset().top - base.offset().top + base.scrollTop() - header;
			base.animate({scrollTop: top}, 1000 * .4);
		};

		setTimeout(scroll, 250);
		*/
	}
</script>

<style>
	div.zes-toolbar {
		display: none;
		padding: .75em 1.25em;
		background: var(--zes-1-3);
	}

	div.zes-group-duo {
		display: flex;
		justify-content: space-between;
		gap: 1em;
	}

	div.zes-group-duo div {
		width: 50%;
	}

	div.zes-group-duo div:first-child {
		color: var(--zes-3-1);
	}

	div.zes-group div {
		font-weight: 700;
		text-align: center;
		text-transform: uppercase;
		color: var(--zes-1-2);
		padding: .5em;
		border-radius: .35em;
		background: hsl(0deg 0% 100%);
	}

	div.zes-group div i {
		margin-left: .5em;
	}

	div.zes-group div.zes-icon-first i {
		margin-right: .5em;
		margin-left: 0;
	}

	@media only screen and (max-width: 1024px) {
		div.zes-toolbar {
			display: block;
		}
	}
</style>

{#if $Layout.type !== 'quotation'}
	<div class="zes-toolbar">
		{#if $Layout.type !== 'product'}
			<div class="zes-group">
				<div class="zes-attention" on:click="{event => configurator() }">
					Configureren <i class="fa-light fa-circle-chevron-right"></i>
				</div>
			</div>
		{:else}
			<div class="zes-group zes-group-duo">
				<div on:click="{event => previous()}" class="zes-icon-first">
					<i class="fa-light fa-circle-chevron-left"></i> Vorige
				</div>
				<div on:click="{event => next()}">
					Volgende <i class="fa-light fa-circle-chevron-right"></i>
				</div>
			</div>
		{/if}
	</div>
{/if}